import Profile from '../components/Profile/Profile';

const ProfilePage = () => (
  <div>
    <Profile />
  </div>
);
export default ProfilePage;
